import(/* webpackMode: "eager", webpackExports: ["Table","TableBody","TableRow","TableCell"] */ "/Users/christophkranebitter/renehuemer.com/website/src/components/ui/table.tsx");
